// import React, { useContext, useEffect, useState } from 'react';
// import { InputLabel, Button } from '@material-ui/core';
// import ThemeControls from "../Component/AllThemesControl.js";
// import FormHelperText from '@mui/material/FormHelperText';
// import OutlinedInput from '@mui/material/OutlinedInput';
// import elementValidation from '../Component/validation.js';
// import { FormContext } from '../Component/Forms/FormContext.js';

// export default function Input(props) {
//   const { useStyle } = ThemeControls;
//   const classes = useStyle();

//   const { id, field_unique, field_disabled_Edit, field_type, field_id, field_apipath, field_disabled, field_label, field_placeholder, field_value, field_options, field_helperText, field_minlength, field_maxlength, field_maxvalue, field_value_type, field_minvalue, field_error_msg_required, field_error_msg_minlength, field_error_msg_maxlength, field_error_msg_minvalue, field_error_msg_maxvalue, field_error_msg_uq, field_mandatory } = props;
//   const { handleChange } = useContext(FormContext)
  
//   const [customFields, setCustomFields] = useState(false);

//   const elementField = { id, field_unique, field_disabled_Edit, field_type, field_disabled, field_id, field_apipath, field_label, field_placeholder, field_value, field_options, field_helperText, field_minlength, field_maxlength, field_maxvalue, field_value_type, field_minvalue, field_error_msg_required, field_error_msg_minlength, field_error_msg_maxlength, field_error_msg_minvalue, field_error_msg_maxvalue, field_error_msg_uq, field_mandatory };

//   const handleAddField = () => {
//     setCustomFields(true)
//   };

//   const handleRemoveField = () => {
//     setCustomFields(false)
//   };

//   const handleFieldChange = (index, value) => {
//     const updatedFields = [...customFields];
//     updatedFields[index].value = value;
//     setCustomFields(updatedFields);
//   };

//   const handleBlur = () => {
//     elementValidation(elementField);
//   };

//   useEffect(() => {
//     console.log(customFields)
//     handleChange(field_id,{},{})
//   }, [customFields]);

//   return (
//     <div className={classes.customInput}>
//       <div style={{ display: "flex" }}>
//         <InputLabel className={classes.label}>{props.field_label}</InputLabel>{props.field_mandatory === "yes" ? <span style={{
//           fontSize: "18px",
//           color: "#d71729",
//           fontWeight: "400",
//           lineHeight: "20px",
//           transform: "translateY(-2px)"
//         }}>*</span> : null}
//       </div>
//       <div className="inputRow">
//       <OutlinedInput className={classes.input}
//              id = {field_id}
//              type={field_type}
//              value={field_value}
//              placeholder={field_placeholder ? field_placeholder : ''} 
//              onChange={event => handleChange(field_id,{},event.target.value)}
//              error
//              onBlur={()=>(handleBlur())}
//         />
//           <Button onClick={handleAddField} disabled={customFields}>+</Button>
//         </div>
//         {customFields&&<div className="inputRow">
//           <OutlinedInput className={classes.input}
//               // id = {field_id}
//               type={field_type}
//               value={field_value}
//               placeholder={field_placeholder ? field_placeholder : ''} 
//               onChange={event => handleChange(field_id,{},event.target.value)}
//               error
//             onBlur={() => handleBlur()}
//           />
//           <Button onClick={handleRemoveField}>-</Button>
//         </div>}
//       <FormHelperText>{props.field_helperText || elementField.field_helperText}</FormHelperText>
//     </div>
//   );
// }


import React, { useContext, useEffect, useState } from 'react';
import { InputLabel, Button } from '@material-ui/core';
import ThemeControls from "../Component/AllThemesControl.js";
import FormHelperText from '@mui/material/FormHelperText';
import OutlinedInput from '@mui/material/OutlinedInput';
import elementValidation from '../Component/validation.js';
import { FormContext } from '../Component/Forms/FormContext.js';
import { TroubleshootOutlined } from '@mui/icons-material';

export default function Input(props) {
  const { useStyle } = ThemeControls;
  const classes = useStyle();
  
  const { id, field_unique, field_disabled_Edit, field_type, field_id, field_apipath, field_disabled, field_label, field_placeholder, field_value, field_value_2, field_helperText, field_minlength, field_maxlength, field_maxvalue, field_value_type, field_minvalue, field_error_msg_required, field_error_msg_minlength, field_error_msg_maxlength, field_error_msg_minvalue, field_error_msg_maxvalue, field_error_msg_uq, field_mandatory } = props;
  const { handleChange } = useContext(FormContext);

  const elementField = { id, field_unique, field_disabled_Edit, field_type, field_disabled, field_id, field_apipath, field_label, field_placeholder, field_value, field_helperText, field_minlength, field_maxlength, field_maxvalue, field_value_type, field_minvalue, field_error_msg_required, field_error_msg_minlength, field_error_msg_maxlength, field_error_msg_minvalue, field_error_msg_maxvalue, field_error_msg_uq, field_mandatory };

  const [customFields, setCustomFields] = useState(false);
  const [inputValue, setInputValue] = useState({ [field_id]: field_value, [field_id + 2]: field_value_2 });
  let filedStatus = false 

  useEffect(() => {
    setInputValue({ [field_id]: field_value, [field_id + 2]: field_value_2 })
    if(field_value_2){
      setCustomFields(TroubleshootOutlined)
    }
  }, [field_value, field_value_2]);

  const handleAddField = () => {
    filedStatus = true
    setCustomFields(true);
  };

  const handleRemoveField = () => {
    setInputValue(prevState => ({
      ...prevState,
      [field_id + 2]: '',
    }));
    filedStatus = false
    setCustomFields(false);
  };

  const handleBlur = () => {
    elementValidation(elementField);
  };

  const handleInputChange = (id, event) => {
    const { value } = event.target;
    setInputValue(prevState => ({
      ...prevState,
      [id]: value,
    }));
  };

  useEffect(() => {
    handleChange(field_id, inputValue[field_id + 2], inputValue[field_id]);
  }, [inputValue]);

  return (
    <div className={classes.customInput}>
      <div style={{ display: "flex" }}>
        <InputLabel className={classes.label}>{field_label}</InputLabel>
        {field_mandatory === "yes" ? (
          <span
            style={{
              fontSize: "18px",
              color: "#d71729",
              fontWeight: "400",
              lineHeight: "20px",
              transform: "translateY(-2px)"
            }}
          >
            *
          </span>
        ) : null}
      </div>
     <div>
     <div className="inputRow">
        <OutlinedInput
          className={classes.input}
          id={field_id}
          type={field_type}
          value={inputValue[field_id]}
          placeholder={field_placeholder ? field_placeholder : ""}
          onChange={(e)=>handleInputChange(field_id, e)}
          onBlur={handleBlur}
        />
        <Button onClick={handleAddField} >
          +
        </Button>
      </div>
      {(customFields || filedStatus || inputValue[field_id + 2]) && (
        <div className="inputRow">
          <OutlinedInput
            id={field_id + 2}
            className={classes.input}
            type={field_type}
            value={inputValue[field_id + 2]}
            placeholder={field_placeholder ? field_placeholder : ""}
            onChange={(e)=>handleInputChange(field_id + 2, e)}
            onBlur={handleBlur}
          />
          <Button onClick={handleRemoveField}>-</Button>
        </div>
      )}
     </div>
      <FormHelperText>{field_helperText || elementField.field_helperText}</FormHelperText>
    </div>
  );
}
